/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';
import challan_style from './challan-print/challan-style';
import Portal from 'components/base/Portal';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import fetchData from 'services/fetchData';
import apiEndpoints from 'constants/apiEndpoints';
import useFetchData from 'hooks/custom/useFetchData';
import dayjs from 'dayjs';
import PageLoader from 'components/custom/animate-component/PageLoader';
import kerpLogo from 'assets/img/logos/kerp-challan-logo.png';
import challanLogo from 'assets/img/logos/challan_logo_img.jpeg';
import challanAddress from 'assets/img/logos/challan_logo_address.png';

const ChallanPrintButton = ({ id }) => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [printData, setPrintData] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchRequest = async challanId => {
    setLoading(true);
    const response = await fetchData(apiEndpoints.challan.getChallanPrint(id));

    if (response.status) {
      const fetchedData = response.data;
      setPrintData(fetchedData);
      setIsPrinting(true);
      setTimeout(() => {
        setLoading(false);
      }, 200);
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        // onClick={() => setIsPrinting(true)}
        onClick={fetchRequest}
        startIcon={<Icon className="fs-9" icon={'lets-icons:print-light'} />}
        variant={`phoenix-primary`}
        className="white-space-nowrap px-2 py-1 fs-9 font-outfit fw-normal mb-1"
      >
        Print
      </Button>
      {/* {loading && (
        <Portal>
          <PageLoader loading={loading} loadingMessage={'Printing challan'} />
        </Portal>
      )} */}

      {isPrinting && !loading && (
        <ChallanPrint
          printData={printData}
          onComplete={() => setIsPrinting(false)}
        />
      )}
    </>
  );
};

const ChallanPrint = ({ onComplete = () => {}, printData }) => {
  const barCodeRef = useRef(null);
  const {
    challan_no,
    vehicle_number,
    challan_date,
    from_city_name,
    to_city_name,
    do_number,
    po_number,
    permit_number,
    gate_pass_no,
    schedule_delivery_date,
    driver_name,
    driver_mobile,
    driver_license_number,
    reachout_time,
    location_name,
    gross_weight,
    tare_weight,
    net_weight,
    material_name,
    material_rate,
    e_way_bill_no,
    invoice_amount,
    diesel_amount,
    cash_advance,
    fuel_station,
    fuel_slip_no,
    consigner_address,
    consigner_gst_number,
    consigner_name,
    consigner_phone,
    consigner_contact_person_name,
    consignee_contact_person_name,
    consigner_zip_code,
    consigner_country_name,
    consigner_state_name,
    consigner_city_name,
    consignee_address,
    consignee_gst_number,
    consignee_name,
    consignee_phone,
    consignee_zip_code,
    consignee_country_name,
    consignee_state_name,
    consignee_city_name,
    destination_name,
    request_by
  } = printData.challan_print_detail;

  const a = dayjs();
  const b = a.add(reachout_time, 'hour');
  const formattedDate = b.format('DD-MM-YYYY HH:mm');
  useEffect(() => {
    // Generate barcode when component mounts
    if (barCodeRef.current) {
      JsBarcode(barCodeRef.current, challan_no, {
        width: 2,
        height: 30,
        displayValue: false
      });
    }
  }, [challan_no]);

  function printLR(labels) {
    const challan = document.getElementById('challan');

    var popupWin = window.open('', '_blank');
    if (popupWin?.document) {
      popupWin.document.open();
      popupWin.document.write(
        `<html>
        <head>
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/css/bootstrap.min.css"
          />
          <style>${challan_style}</style>
          <style>
            @page { size: 210mm 297mm; margin: 0; padding: 0; }
            @media print { 
              @page { size: 210mm 297mm; }
              table, td, tr { padding: 7px !important; line-height: 20px !important; font-size: 18px !important; }
            }
          </style>
        </head>
        <style type="text/css">
          @media print {
            .hide-on-print {
              display: none;
            }
            body {
              background-color: white !important;
              padding: 15px;
            }

            * {
              font-size: 97% !important;
              font-family: Arial !important;
            }

            @page {
              margin: 5px;
            }

            .container {
              width: -webkit-fill-available;
            }

            #title_tag {
              background-color: #ddd !important;
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
          }

          @media (min-width: 1200px) {
            .container {
              max-width: 1200px;
            }
          }

          table,
          td,
          th {
            border: 1px solid #c7c7c7;
            padding: 7px !important;
            line-height: 15px !important;
          }

          #title_tag {
            font-size: 100% !important;
            background-color: #ddd;
            color: black;
            text-align: center;
          }

          #element_tag {
            font-size: 100% !important;
            color: black;
            text-align: left;
          }

          .word-wrap {
            word-break: break-all;
          }

          .LR {
            page-break-inside: avoid;
          }
        </style>
        <body onload="window.print()" style="margin: 0;">`
      );

      popupWin.document.write(challan?.innerHTML);

      labels.forEach((label, index) => {
        if (index > 0) {
          const lrElements = popupWin.document.getElementsByClassName('LR');
          const firstLRElement = lrElements[0].cloneNode(true);
          const existingLabel =
            firstLRElement.getElementsByClassName('lr-label');
          existingLabel[0].parentNode.removeChild(existingLabel[0]);
          lrElements[0].parentNode.appendChild(firstLRElement);
        }

        const lrElements = popupWin.document.getElementsByClassName('LR');
        lrElements[index]?.insertAdjacentHTML(
          'afterbegin',
          `<label class="col-md-3 control-label lr-label" style="font-size: 15px !important;">${label}</label>`
        );
      });

      const style = popupWin.document.createElement('style');
      style.media = 'print';

      const pageSize = 'Landscape';

      style.appendChild(
        popupWin.document.createTextNode(`@page { size: ${pageSize}; }`)
      );

      if (pageSize === 'Portrait') {
        style.appendChild(
          popupWin.document.createTextNode(
            'table,td,tr { padding: 2px 7px !important; }'
          )
        );
      } else {
        style.appendChild(
          popupWin.document.createTextNode(
            'table,td,tr { padding: 7px !important; line-height: 20px !important; font-size: 18px !important; }'
          )
        );
      }

      popupWin.document.head.appendChild(style);

      const title =
        labels.length === 1 ? `C2024/09/1282 ${labels[0]}` : 'C2024/09/1282 LR';
      popupWin.document.title = title;

      popupWin.document.write('</html>');
      popupWin.document.close();
      popupWin.onload = () => {
        popupWin.print({
          header: false,
          footer: false
        });
        setTimeout(() => {
          popupWin.close();
        }, 1000); // Adjust the delay as needed
      };
    }
    onComplete();
  }

  // On single click download all lr copies
  function downloadConsignerConsigneeAckCopies() {
    printLR(['Consigner Copy', 'Transporter Copy']);
  }

  useEffect(() => {
    setTimeout(downloadConsignerConsigneeAckCopies, 300);
  }, [downloadConsignerConsigneeAckCopies]);

  return (
    <Portal>
      <div
        id="challan"
        style={{ zIndex: '-1', position: 'fixed', top: '0', left: '-100vw' }}
      >
        <div className="container custom_css">
          <div className="row LR">
            <table className="table" style={{ tableLayout: 'fixed' }}>
              <tbody>
                <tr>
                  <th
                    rowSpan={4}
                    colSpan={2}
                    style={{ verticalAlign: 'middle' }}
                    width="30%"
                  >
                    <div className="logo center">
                      <img
                        id="logo"
                        // src="https://s3.ap-south-1.amazonaws.com/cargofl-ktc-prod-1/GMU6721_2021-10-22 13:01:28.png"
                        src={challanLogo}
                        style={{ width: 350, height: 55, display: 'inline' }}
                        alt=""
                      />
                      <img
                        id="logo_address"
                        // src="https://s3.ap-south-1.amazonaws.com/cargofl-ktc-prod-1/GMU6721_2021-10-22 13:01:28.png"
                        src={challanAddress}
                        style={{ width: 350, height: 80, display: 'inline' }}
                        alt=""
                      />
                    </div>
                  </th>
                  <th colSpan={2} style={{ textAlign: 'center' }} width="35%">
                    <small>
                      <strong>
                        PAN: AAHCK8673M &nbsp; &nbsp;GST: 21AAHCK8673M1Z1
                      </strong>
                    </small>
                  </th>
                  <td
                    rowSpan={4}
                    colSpan={2}
                    className="text-center"
                    width="30%"
                  >
                    <img id="barcode" ref={barCodeRef} />
                    <br />
                    <span style={{ fontSize: 'medium !important' }}>
                      <b>Challan :</b> {challan_no}
                    </span>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td id="element_tag">Vehicle Number</td>
                  <td>{vehicle_number || '--'}</td>
                </tr>
                <tr>
                  <td id="element_tag">Challan Date</td>
                  <td>{challan_date}</td>
                </tr>
                <tr>
                  <td id="element_tag">From : {location_name}</td>
                  <td id="element_tag">To : {destination_name}</td>
                </tr>
                <tr>
                  <td id="title_tag" colSpan={2}>
                    Consigner
                  </td>
                  <td id="title_tag" colSpan={2}>
                    Consignee
                  </td>
                  <td id="title_tag" colSpan={2}>
                    Driver Details
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} rowSpan={3}>
                    {consigner_name},
                    <br />
                    {consigner_address},
                    <br />
                    {consigner_city_name},{consigner_state_name},
                    {consigner_zip_code}
                    <br />
                    GST: {consigner_gst_number}
                    <br />
                    Point of Contact :{consigner_phone}
                    <br />
                    Contact Person Name :{consigner_contact_person_name}
                    <br />
                  </td>
                  <td colSpan={2} rowSpan={3}>
                    {consignee_name},
                    <br />
                    {consignee_address},
                    <br /> {consignee_city_name}, {consignee_state_name},{' '}
                    {consignee_zip_code}
                    <br />
                    GST: {consignee_gst_number}
                    <br />
                    Point of Contact :{consignee_phone}
                    <br />
                    Contact Person Name :{consignee_contact_person_name}
                    <br />
                    <br />
                  </td>
                  <td>Name</td>
                  <td>{driver_name}</td>
                </tr>
                <tr>
                  <td>Mobile</td>
                  <td>{driver_mobile}</td>
                </tr>
                <tr>
                  <td>Driving License</td>
                  <td>{driver_license_number}</td>
                </tr>
                <tr>
                  <td id="title_tag">Gross Weight (MT)</td>
                  <td id="title_tag">Tare Weight (MT)</td>
                  <td id="title_tag">Net Weight (MT)</td>
                  <td id="title_tag">Acutal Qty (MT)</td>
                  <td id="title_tag" colSpan={2}>
                    Financial and Fuel Details
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center' }}>
                    <b>{gross_weight}</b>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <b>{tare_weight}</b>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <b>{net_weight}</b>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <b>{net_weight}</b>
                  </td>
                  <td id="element_tag">Fuel Station / Fuel Slip No</td>
                  <td id="freight">
                    {fuel_station} / {fuel_slip_no}
                  </td>
                </tr>
                <tr>
                  <td id="title_tag">Packaging Type</td>
                  <td id="title_tag">Material</td>
                  <td id="title_tag" style={{ textAlign: 'center' }}>
                    Rate / MT
                  </td>
                  <td id="title_tag" style={{ textAlign: 'center' }}>
                    Amount
                  </td>
                  <td id="element_tag">Invoice Amount</td>
                  <td>{invoice_amount}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center' }}>LOOSE</td>
                  <td style={{ textAlign: 'center' }}>{material_name}</td>
                  <td style={{ textAlign: 'center' }}>{material_rate}</td>
                  <td style={{ textAlign: 'center' }}>TO BE BILLED </td>
                  <td id="element_tag">Advance</td>
                  <td id="total">{cash_advance}</td>
                </tr>
                <tr>
                  <td id="title_tag">Inv/T.P.No</td>
                  <td id="title_tag">D.O. No</td>
                  <td id="title_tag">P. O. No.</td>
                  <td id="title_tag">E-Way Bill No.</td>
                  <td id="element_tag">Diesel Amount</td>
                  <td id="advance">{diesel_amount}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center' }}>
                    {permit_number}/{gate_pass_no}
                  </td>
                  <td style={{ textAlign: 'center' }}>{do_number}</td>
                  <td style={{ textAlign: 'center' }}>{po_number}</td>
                  <td style={{ textAlign: 'center' }}>{e_way_bill_no}</td>
                  <td id="element_tag">Generated by</td>
                  <td id="advance">{request_by || ''}</td>
                  <td />
                </tr>
                <tr>
                  <td id="title_tag" colSpan={2}>
                    Declaration
                  </td>
                  <td id="title_tag" colSpan={2}>
                    Reachout Location and Time
                  </td>
                  <td
                    colSpan={2}
                    id="element_tag"
                    style={{ textAlign: 'center !important' }}
                  >
                    Contact @ +91-9040624110
                  </td>
                </tr>
                <tr>
                  <td id="element_tag" colSpan={2}>
                    <center>This is Computer Generated Road Challan</center>
                  </td>
                  <td
                    id="element_tag"
                    colSpan={2}
                    style={{ textAlign: 'center' }}
                  >
                    Plant Main Gate Before: {formattedDate || '--'}
                  </td>
                  <td
                    colSpan={2}
                    id="element_tag"
                    style={{ textAlign: 'center !important' }}
                  >
                    For KALYANI TRANSCO PVT. LTD.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export { ChallanPrintButton };
export default ChallanPrint;
